export const INTELLIGENCE_RELATED = 'intl.';
export const INTELLIGENCE_BASE = 'intl.analyze';
export const INBOX_FEATURE_ACCESS = [INTELLIGENCE_RELATED];
export const TAB_FORENSICS_FEATURE = 'forensics.investigate';
export const TAB_FORENSICS_QUICK_INVESTIGATION_FEATURE = 'forensics.quick_investigation';
export const TAB_VIEW_AUTHOR_INVESTIGATION_FEATURE = 'view.author_investigation';

// TEM
export const TEM_ACCESS = 'tem.access';
export const TEM_LIVE_ATTACK_MAP = 'tem.live_attack_map';

// TI
export const SEARCH_MALWARE_LOG_SHOPS = 'intl.search.marketplace.malware_logs';
export const SEARCH_GITHUB = 'intl.search.code_repos.github';
export const SEARCH_POSTMAN = 'intl.search.code_repos.postman';
export const SEARCH_ENGINE_GRAY = 'intl.search.search_engine.grayhatwarfare'; // Open Bucket
export const SEARCH_GOOGLE = 'intl.search.search_engine.google'; // Dorks
export const SEARCH_SCRIBD = 'intl.search.search_engine.scribd';
export const TI_FEATURES = [
  INTELLIGENCE_BASE,
  SEARCH_MALWARE_LOG_SHOPS,
  SEARCH_GITHUB,
  SEARCH_POSTMAN,
  SEARCH_ENGINE_GRAY,
  SEARCH_GOOGLE,
  SEARCH_SCRIBD
];

// DRP
export const SEARCH_YOUTUBE = 'intl.search.social_media.youtube';
export const SEARCH_APP_STORE_OFFICIAL = 'intl.search.app_store.official';
export const SEARCH_APP_STORE_3RD = 'intl.search.app_store.third_party';
// DRP
export const PHISHING_SQUATTING_ANALYSIS = 'phishint.analysis.squatting'; // Look alike
export const PHISHING_CONTENT_ANALYSIS = 'phishint.analysis.content'; // Phishing
// SM DRP
export const SM_PAGE_FACEBOOK = 'intl.search.social_media.pages.facebook';
export const SM_PAGE_INSTAGRAM = 'intl.search.social_media.pages.instagram';
export const SM_PAGE_TIKTOK = 'intl.search.social_media.pages.tiktok';
export const SM_PAGE_TWITTER = 'intl.search.social_media.pages.twitter';
export const SM_PAGE_LINKEDIN = 'intl.search.social_media.pages.linkedin';

export const SEARCH_TWITTER = 'intl.search.social_media.twitter';
export const DRP_FEATURES = [
  SEARCH_YOUTUBE,
  SEARCH_APP_STORE_OFFICIAL,
  SEARCH_APP_STORE_3RD,
  SEARCH_TWITTER,
  PHISHING_SQUATTING_ANALYSIS,
  PHISHING_CONTENT_ANALYSIS,
  SM_PAGE_FACEBOOK,
  SM_PAGE_INSTAGRAM,
  SM_PAGE_TIKTOK,
  SM_PAGE_TWITTER,
  SM_PAGE_LINKEDIN
];

export const SM_FEATURES = [SM_PAGE_FACEBOOK, SM_PAGE_INSTAGRAM, SM_PAGE_TIKTOK, SM_PAGE_TWITTER, SM_PAGE_LINKEDIN];
export const SM_DUMMY_KEY = 'social_media_pages'; // FE key for use SM FF
// export const ASM_DUMMY_KEY = 'asm_dummy_key'; // FE key for ASM usage

// Data Lake
export const IOC_VIEW = 'view.ioc';
export const INTELLIGENCE_ARCHIVE_VIEW = 'view.intelligence_archive';
export const GLOBAL_SEARCH = 'feeds.indicators';

// Saved Queries
export const SAVED_QUERY_DATA_LAKE_MONITOR = 'saved_query.data_lake_monitor';
export const SAVED_QUERY_RAW_INTEL_MONITOR = 'saved_query.raw_intel_monitor';

export const API_TRANSLATE_PREFIX = 'api.translate.';
export const LIMITED_TRANSLATE = `${API_TRANSLATE_PREFIX}limited`;
export const UNLIMITED_TRANSLATE = `${API_TRANSLATE_PREFIX}unlimited`;

export const EMAIL_SEND = 'collaboration.email';
export const COMMENTS_COMMENT = 'collaboration.comment';
export const COLLABORATION_REPORTS = 'collaboration.reports';

export const FEEDS_CREDENTIALS = 'feeds.credentials';
export const THREAD_VIEW = 'view.thread_view';

export const ASM_FEATURE_VIEW = 'view.my_digital_footprint';
export const ASM_FEATURE_MONITOR = 'my_digital_footprint.monitor';
export const ASM_FEATURE_ACCESS = 'my_digital_footprint.access';
export const ATTACK_SURFACE_MONITORING_DEMO = 'my_digital_footprint.demo';
export const ATTACK_SURFACE_MONITORING_ASSET_DISCOVERY = 'my_digital_footprint.action.discovery.full';
export const ATTACK_SURFACE_MONITORING_IN_SCOPE_SCAN = 'my_digital_footprint.action.scan.in_scope';
export const ATTACK_SURFACE_MONITORING_ISSUE_DETECTION = 'my_digital_footprint.action.scan.full';
export const ATTACK_SURFACE_MONITORING_SCORE_CALCULATION = 'my_digital_footprint.action.score';
export const ATTACK_SURFACE_MONITORING_SECURITY_POSTURE_SCORE_CALCULATION =
  'my_digital_footprint.action.security_posture_score';
export const ATTACK_SURFACE_MONITORING_FULL_SCHEDULED_DISCOVERY = 'my_digital_footprint.discovery.scheduled.full';
export const ATTACK_SURFACE_MONITORING_VALIDATION = 'my_digital_footprint.action.validation';
export const ATTACK_SURFACE_MONITORING_LICENSE_VIEW = 'my_digital_footprint.asset_license_view';
export const ATTACK_SURFACE_MONITORING_SCORE = 'my_digital_footprint.action.score';
export const ATTACK_SURFACE_MONITORING_TECHNOLOGY_DISCOVERY = 'my_digital_footprint.action.technology_discovery';
export const ATTACK_SURFACE_MONITORING_ACTIVE_VULNERABILITY_SCAN = 'my_digital_footprint.action.exploitability_scan';
export const ATTACK_SURFACE_MONITORING_FULL_SCHEDULED_ACTIVE_VULNERABILITY_SCAN =
  'my_digital_footprint.exploitability_scan.scheduled.full';

export const ATTACK_SURFACE_MONITORING_ACTIVE_VULNERABILITY_VALIDATION =
  'my_digital_footprint.action.exploitability_validation';
export const ATTACK_SURFACE_MONITORING_FULL_SCHEDULED_ACTIVE_VULNERABILITY_VALIDATION =
  'my_digital_footprint.exploitability_validation.scheduled.full';
export const ATTACK_SURFACE_MONITORING_INTEGRATIONS_QUANTUM = 'my_digital_footprint.integrations.quantum';
export const ATTACK_SURFACE_MONITORING_INTEGRATIONS_CAASM = 'my_digital_footprint.integrations.caasm';

export const CAASM_ACCESS = 'caasm.access';

export const INTEL_DATA_LAKE = 'view.intelligence_archive';
export const ALL_FOLDER_ACCESS = 'feeds.indicators';

export const ALERTS_VIEW = 'view.alerts';
export const CYCLOPS_TABS = 'view.cyclops_tabs';
export const ALERTS_CREATE = 'alerts.create';
export const ALERTS_CLONE = 'alerts.clone';
export const ALERTS_NOTIFICATIONS = 'alerts.notifications';
export const REPORTS_NOTIFICATIONS = 'reports.notifications';
export const NEWS_TICKER_ACCESS = 'non_targeted_intelligence.news.access';
export const CVE_ACCESS = 'non_targeted_intelligence.cve.access';
export const TIP_ACCESS = 'tip.access'; // IOC Management
export const ASSET_GROUPING_VIEW = 'view.asset_attribution';

export const MY_ACCOUNT_FEATURE = 'view.my_account';
export const LICENSE_TENANT_TYPES = 'license.tenant_types';
export const HOME_FEATURE = 'view.home';
export const MSSP_ALERT_CENTER = 'view.mssp_alert_center';

export const DOMAIN_SQUATTING_COLLECTION = 'phishint.collection.squatting';
export const MONITOR_FOR_PHISHING = 'phishint.analysis.content';
export const PHISHINT_URL_RULES_VIEW = 'phishint.url_rules.view';
export const PHISHINT_URL_RULES_MANAGE = 'phishint.url_rules.manage';

export const TAKEDOWN_SUBMIT = 'takedown.submit';
export const TAKEDOWN_NOTIFICATION = 'takedown.notifications';

export const VIEW_EXECUTIVE_DASHBOARDS = 'view.executive_dashboard';
export const AUTOMATIC_ALERTS_CUSTOMER_CREDENTIALS = 'alerts.automatic.customer_credentials';
export const AUTOMATIC_ALERTS_CORP_CREDENTIALS_EXPOSED = 'alerts.automatic.employee_corporate_credentials';
export const AUTOMATIC_ALERTS_3RD_PARTY_CREDENTIALS_EXPOSED = 'alerts.automatic.employee_third_party_credentials';
export const AUTOMATIC_ALERTS_INFECTED_MACHINE = 'alerts.automatic.employee_machine_infected_by_malware';
export const AUTOMATIC_ALERTS_VULNERABLE_TECHNOLOGY_ON_ASSET =
  'alerts.automatic.vulnerable_technology_detected_on_exposed_company_asset';
export const AUTOMATIC_ALERTS_VULNERABLE_TECHNOLOGY_ON_MANUALLY_ADDED_TECHNOLOGY =
  'alerts.automatic.vulnerable_technology_detected_on_manually_added_technology';

export const AUTOMATIC_ALERT_EXPLOITABLE_VULNERABILITY_FOUND_ON_COMPANY_ASSET =
  'alerts.automatic.exploitable_vulnerability_found_on_company_asset';
export const AUTOMATIC_ALERT_EXPLOIT_FOUND_ON_COMPANY_ASSET = 'alerts.automatic.exploit_found_on_company_asset';
export const AUTOMATIC_PAYMENT_CARDS_EXPOSED = 'alerts.automatic.payment_cards';

export const AUTOMATIC_ALERTS_EXPLOITABLE_PORT = 'alerts.automatic.exploitable_port';
export const AUTOMATIC_ALERTS_PHISHING_WEBSITE = 'alerts.automatic.phishing_website';
export const AUTOMATIC_ALERTS_LOOKALIKE_DOMAIN = 'alerts.automatic.lookalike_domain';

export const AUTOMATIC_ALERTS_HIJACKABLE_SUBDOMAIN = 'alerts.automatic.hijackable_subdomains';
export const AUTOMATIC_ALERTS_EXPOSED_ACCESS_TOKEN = 'alerts.automatic.exposed_access_token';

export const AUTOMATIC_ALERTS_EXPOSED_CLOUD_STORAGE = 'alerts.automatic.exposed_cloud_storage';
export const AUTOMATIC_ALERTS_EXPOSED_WEB_INTERFACE = 'alerts.automatic.exposed_web_interface';
export const AUTOMATIC_ALERTS_MISSING_COMPANY_DOMAIN_SPF_RECORDS = 'alerts.automatic.email_security_missing_spf';
export const AUTOMATIC_ALERTS_MISSING_COMPANY_DOMAIN_DMARC_RECORDS = 'alerts.automatic.email_security_missing_dmarc';
export const AUTOMATIC_ALERTS_MISSING_COMPANY_DOMAIN_CAA_RECORDS = 'alerts.automatic.missing_caa';
export const AUTOMATIC_ALERTS_COMPANY_MAIL_SERVER_BLOCKLISTED = 'alerts.automatic.company_mail_server_blocklisted';
export const AUTOMATIC_ALERTS_MOBILE_APP_DISTRIBUTED_UNOFFICIALLY =
  'alerts.automatic.mobile_app_distributed_unofficially';
export const AUTOMATIC_ALERTS_MOBILE_APP_IMPERSONATING_COMPANY = 'alerts.automatic.mobile_app_impersonating_company';
export const AUTOMATIC_ALERTS_SSL_CERTIFICATE_EXPIRE = 'alerts.automatic.ssl_certificate_expiry';
export const AUTOMATIC_SM_ACCOUNT_IMPERSONATING_COMPANY = 'alerts.automatic.social_media_account_impersonating_company';
export const AUTOMATIC_SM_ACCOUNT_IMPERSONATING_COMPANY_EXECUTIVE =
  'alerts.automatic.social_media_account_impersonating_company_executive';

// Experimental features
export const AUTOMATIC_ALERTS_MALICIOUS_FILE_TARGETING_EMPLOYEES =
  'alerts.automatic.malicious_file_targeting_employees';
export const AUTOMATIC_ALERTS_INTERNAL_EMAIL_CORRESPONDENCE = 'alerts.automatic.internal_email_correspondence';
export const AUTOMATIC_ALERTS_CUSTOMER_CREDENTIALS_OFFERED_FOR_SALE =
  'alerts.automatic.customer_credentials_offered_for_sale';
export const AUTOMATIC_ALERTS_EMPLOYEE_CREDENTIALS_OFFERED_FOR_SALE =
  'alerts.automatic.employee_credentials_offered_for_sale';
export const AUTOMATIC_ALERTS_CUSTOMER_PAYMENT_CARDS_OFFERED_FOR_SALE =
  'alerts.automatic.customer_payment_cards_offered_for_sale';
export const AUTOMATIC_ALERTS_COMPANY_SOURCE_CODE_EXPOSED = 'alerts.automatic.company_source_code_exposed';
export const AUTOMATIC_ALERTS_RANSOMWARE_ATTACK_TARGETING_COMPANY =
  'alerts.automatic.ransomware_attack_targeting_company';
export const AUTOMATIC_ALERTS_FRAUDULENT_REFUND_SERVICES_TARGETING_COMPANY =
  'alerts.automatic.fraudulent_refund_services_targeting_company';
export const AUTOMATIC_ALERTS_FRAUDULENT_REFUND_TUTORIAL_TARGETING_COMPANY =
  'alerts.automatic.fraudulent_refund_tutorial_targeting_company';
export const AUTOMATIC_ALERTS_CREDENTIAL_STUFFING_TARGETING_COMPANY =
  'alerts.automatic.credential_stuffing_tool_targeting_company';
export const AUTOMATIC_ALERTS_COMPANY_CONFIDENTIAL_FILE_EXPOSED = 'alerts.automatic.company_confidential_file_exposed';
export const AUTOMATIC_ALERTS_BREACHED_DATA_POTENTIALLY_RELATED_TO_COMPANY =
  'alerts.automatic.breached_data_potentially_related_to_company';
export const AUTOMATIC_ALERTS_PHISHING_KIT_TARGETING_COMPANY = 'alerts.automatic.phishing_kit_targeting_company';
export const AUTOMATIC_ALERTS_DATA_SCRAPING_TOOL_FOR_COMPANY_APPLICATION =
  'alerts.automatic.data_scraping_tool_for_company_application';
export const AUTOMATIC_ALERTS_FRAUDULENT_ACCOUNT_TEMP_PHONE = 'alerts.automatic.fraudulent_account_temp_phone';

// Supply chain automatic alerts
export const AUTOMATIC_ALERTS_RANSOMWARE_ATTACK_TARGETING_THIRD_PARTY_VENDOR =
  'alerts.automatic.ransomware_attack_targeting_third_party_vendor';
export const AUTOMATIC_ALERTS_THIRD_PARTY_VENDOR_BREACHED = 'alerts.automatic.third_party_vendor_breached';

// SSL/TLS automatic alerts
export const AUTOMATIC_ALERTS_TLS_OUTDATED_VERSION_SSL_TLS_SUPPORTED =
  'alerts.automatic.tls_outdated_version_ssl_tls_supported';
export const AUTOMATIC_ALERTS_TLS_LATEST_VERSION_NOT_SUPPORTED = 'alerts.automatic.tls_latest_version_not_supported';
export const AUTOMATIC_ALERTS_TLS_NO_FORWARD_SECRECY = 'alerts.automatic.tls_no_forward_secrecy';
export const AUTOMATIC_ALERTS_TLS_SERVER_HAS_KNOWN_VULNERABILITY =
  'alerts.automatic.tls_server_has_known_vulnerability';
export const AUTOMATIC_ALERTS_TLS_INSECURE_CIPHER_SUITES = 'alerts.automatic.tls_insecure_cipher_suites';
export const AUTOMATIC_ALERTS_TLS_WEAK_CIPHER_SUITES = 'alerts.automatic.tls_weak_cipher_suites';
export const AUTOMATIC_ALERTS_TLS_SERVER_ACCEPTS_INSECURE_RENEGOTIATION =
  'alerts.automatic.tls_server_accepts_insecure_renegotiation';

// WEB APP SECURITY
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_HSTS_HEADER_DETECTED =
  'alerts.automatic.web_app_security_missing_hsts_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISCONFIGURED_HSTS_HEADER_DETECTED =
  'alerts.automatic.web_app_security_misconfigured_hsts_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_X_FRAME_OPTIONS_HEADER_DETECTED =
  'alerts.automatic.web_app_security_missing_x_frame_options_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISCONFIGURED_X_FRAME_OPTIONS_HEADER_DETECTED =
  'alerts.automatic.web_app_security_misconfigured_x_frame_options_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED =
  'alerts.automatic.web_app_security_missing_x_content_type_options_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISCONFIGURED_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED =
  'alerts.automatic.web_app_security_misconfigured_x_content_type_options_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_CONTENT_SECURITY_POLICY_HEADER_DETECTED =
  'alerts.automatic.web_app_security_missing_content_security_policy_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_REFERRER_POLICY_HEADER_DETECTED =
  'alerts.automatic.web_app_security_missing_referrer_policy_header_detected';
export const AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_X_PERMITTED_CROSS_DOMAIN_POLICIES_HEADER_DETECTED =
  'alerts.automatic.web_app_security_missing_x_permitted_cross_domain_policies_header_detected';

// ENVIRONMENT EXPERATION
export const ENVIRONMENT_EXP_AUTO_DISABLE = 'environment_expiration.auto_disable';
export const ENVIRONMENT_EXP_NOTIFICATIONS = 'environment_expiration.notifications';

export const ENV_SUMMARY_FEATURE_VIEW = 'view.environments_summary';
export const AI_SUMMARY = 'ai.summary';
export const AI_PANOPTES = 'ai.panoptes';
export const AI_ALERT_SUMMARY = 'ai.alert_summary';
export const SOCIAL_MEDIA_FAKE_PAGES = 'social_media_fake_pages.access';
export const AUTO_CLOSE_ALERT_FEATURE = 'alerts.close.issues';
// APIs

export const API_QUERY_IOC = 'api.query_ioc';
export const API_IOC_DAILY_FEED = 'api.download_ioc_daily_feed';
export const API_LEAKED_CREDENTIALS = 'api.get_leaked_credentials';
export const API_LEAKED_CREDENTIALS_BROAD_QUERY = 'api.leaked_credentials.allow_search_outside_asset_inventory';

// INTELLIGENCE IOC
export const INTELLIGENCE_IOC_ENRICHMENT = 'intelligence_ioc.api.enrichment';
export const INTELLIGENCE_IOC_PREVENTION = 'intelligence_ioc.feed.prevention';
export const INTELLIGENCE_IOC_DETECTION = 'intelligence_ioc.feed.detection';
export const INTELLIGENCE_IOC_FULL_ACCESS = 'intelligence_ioc.feed.full_access';

// ASSET MGMT

export const ASSET_MGMT_CREATE = 'asset_management.asset_creation_and_management';

// MSSP

export const MSSP_CREDIT_FEATURE = 'view.customer_credit';
export const MSSP_TENANT_CREATION = 'mssp.tenant_creation';
// export const MSSP_ASSETS_UPLOAD = 'mssp.assets_upload';

// SUPPLY CHAIN

export const SUPPLY_CHAIN_VENDOR_ACCESS = 'supply_chain.vendor_inventory.access';
export const SUPPLY_CHAIN_TECH_INVENTORY_MANAGE_MANUAL = 'supply_chain.tech_inventory.manage_manual';

// SUPPLY CHAIN
export const INVESTIGATION_ACCESS = 'investigation.access';
export const INVESTIGATION_NOTIFICATIONS = 'investigation.notifications';

// Credentials purchase
export const CREDENTIAL_PURCHASE_ACCESS = 'credentials_purchase.access';
export const CREDENTIAL_PURCHASE_NOTIFICATIONS = 'credentials_purchase.notifications';

// Comporomised credentials
export const COMPROMISED_CREDENTIALS_ACCESS = 'compromised_credentials.access';

// CP Quantum Integration
export const CP_QUANTUM_INTEGRATION = 'view.cp_quantum_integration';
export const QUANTUM_INTEGRATION_MANAGE = 'my_digital_footprint.integrations.quantum';

export const COMMON_FEATURES = [
  ENVIRONMENT_EXP_AUTO_DISABLE,
  ENVIRONMENT_EXP_NOTIFICATIONS,
  MY_ACCOUNT_FEATURE,
  COLLABORATION_REPORTS,
  LICENSE_TENANT_TYPES
];

export const COMMON_DEFAULT_FEATURES = [...COMMON_FEATURES, NEWS_TICKER_ACCESS, AI_ALERT_SUMMARY];
export const AUTOMATICALLY_ADDED = [ASSET_GROUPING_VIEW];
export const DEFAULT_WITH_AUTO_FEATURES = [...COMMON_DEFAULT_FEATURES, ...AUTOMATICALLY_ADDED];

// we might want to use as if at least tenant have 1 of these, he will be ERM
export const ERM_FEATURES = [
  ALERTS_VIEW,
  ALERTS_CLONE,
  ASM_FEATURE_VIEW,
  INTELLIGENCE_BASE,
  PHISHING_SQUATTING_ANALYSIS,
  TAKEDOWN_SUBMIT,
  REPORTS_NOTIFICATIONS,
  INTELLIGENCE_ARCHIVE_VIEW,
  GLOBAL_SEARCH,
  SUPPLY_CHAIN_VENDOR_ACCESS,
  ASSET_MGMT_CREATE,
  API_LEAKED_CREDENTIALS
];

export const TEM_FEATURES = [
  ENVIRONMENT_EXP_AUTO_DISABLE,
  ENVIRONMENT_EXP_NOTIFICATIONS,
  MY_ACCOUNT_FEATURE,
  LICENSE_TENANT_TYPES,
  TEM_ACCESS,
  TEM_LIVE_ATTACK_MAP
];

export const TEM_MINIMAL_FEATURES = [TEM_ACCESS];
export const TEM_VISIBLE_FEATURES = [TEM_ACCESS, TEM_LIVE_ATTACK_MAP];
export const ALL_TEM_FEATURES = [...TEM_FEATURES, AI_PANOPTES];

// Main-module feature groups, shared by the features form, the tenant wizard and tenant management.
// A tenant "has" a module when it has at least one feature of the group.
export const AEV_VALIDATION_FEATURES = [
  ATTACK_SURFACE_MONITORING_ACTIVE_VULNERABILITY_VALIDATION,
  ATTACK_SURFACE_MONITORING_FULL_SCHEDULED_ACTIVE_VULNERABILITY_VALIDATION
];
export const RAW_INTEL_DATA_COLLECTION_FEATURES = [
  INTELLIGENCE_BASE,
  SEARCH_YOUTUBE,
  SEARCH_GOOGLE,
  SEARCH_SCRIBD,
  SEARCH_APP_STORE_OFFICIAL,
  SEARCH_TWITTER,
  SEARCH_GITHUB,
  SEARCH_POSTMAN,
  SEARCH_APP_STORE_3RD,
  SEARCH_MALWARE_LOG_SHOPS,
  SEARCH_ENGINE_GRAY,
  TAB_VIEW_AUTHOR_INVESTIGATION_FEATURE,
  THREAD_VIEW,
  EMAIL_SEND,
  COMMENTS_COMMENT,
  UNLIMITED_TRANSLATE,
  LIMITED_TRANSLATE
];
export const PHISHING_DETECTION_FEATURES = [
  PHISHING_SQUATTING_ANALYSIS,
  PHISHING_CONTENT_ANALYSIS,
  DOMAIN_SQUATTING_COLLECTION
];
export const SUPPLY_CHAIN_FEATURES = [SUPPLY_CHAIN_VENDOR_ACCESS];
export const CAASM_FEATURES = [CAASM_ACCESS];
